import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['it', 'en', 'es', 'de', 'fr', 'tr'],
  defaultLocale: 'en',
  localePrefix: 'as-needed', // EN at /, others at /it/, /es/, ...
});
